import React, { useState } from "react";
import Subheader from "../../component/Subheader";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

const subheadData = {
  image: "../image/contact-banner.webp",
  heading: "Your Dream Ensemble Is Just a Conversation Away",
};

const occasions = ["Haldi", "Mehandi", "Sangeet", "Wedding", "Festive"];

const consultationTypes = ["In-studio", "Video"];

export default function ContactUs() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);

  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const sourceUrl = typeof window !== "undefined" ? sessionStorage.getItem("source_url") || "" : "";
  const [formData, setFormData] = useState({
    fullname: "",
    mobile: "",
    email: "",
    occasion: "",
    consultation: "",
    wedding_date: "",
    source_url: sourceUrl,
    ip_address: currentUrl,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (name === "fullname") {
      updatedValue = value.replace(/[^a-zA-Z\s]/g, "");
    }

    if (name === "mobile") {
      updatedValue = value.replace(/[^0-9]/g, "");
    }

    setFormData((prev) => ({
      ...prev,
      source_url: sourceUrl,
      ip_address: currentUrl,
      [name]: updatedValue,
    }));
  };

  const handleCaptcha = (value) => {
    setCaptchaToken(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.fullname.trim()) {
      toast.error("Full Name is required.");
      return;
    }

    if (!/^[a-zA-Z\s]+$/.test(formData.fullname)) {
      toast.error("Full Name should contain only letters.");
      return;
    }

    if (!formData.mobile.trim()) {
      toast.error("Phone Number is required.");
      return;
    }

    if (!/^[0-9]+$/.test(formData.mobile)) {
      toast.error("Phone Number should contain only digits.");
      return;
    }

    if (formData.mobile.length !== 10) {
      toast.error("Phone Number should be exactly 10 digits long.");
      return;
    }

    if (!formData.email.trim()) {
      toast.error("Email Address is required.");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      toast.error("Please enter a valid Email Address.");
      return;
    }

    if (!formData.occasion.trim()) {
      toast.error("Occasion is required.");
      return;
    }

    if (!formData.consultation.trim()) {
      toast.error("Preferred Consultation is required.");
      return;
    }

    if (!captchaToken) {
      toast.error("Please complete the CAPTCHA");
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${BaseUrl}/api/consultation-saves`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success === true) {
        navigate("/contact-us/thankyou");
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while submitting the form.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Subheader subheadData={subheadData} />

      <section className="contactpage">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div className="contact-detail">
                {/* <h1 className="heading">Talk To Us</h1> */}
                <img src="/image/shape.webp" alt="shape" className="divider-shape" loading="lazy" />
                <p>
                  From queries to couture &ndash; we&rsquo;re here to help you shine, connect with us to bring your
                  bridal story to life
                </p>
              </div>

              <form id="contact-form" className="contact-form" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <input
                      value={formData.fullname}
                      onChange={handleChange}
                      type="text"
                      name="fullname"
                      placeholder="Full Name*"
                      className="form-control"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <input
                      value={formData.mobile}
                      onChange={handleChange}
                      name="mobile"
                      type="tel"
                      maxLength={10}
                      placeholder="Phone Number*"
                      className="form-control"
                      inputMode="numeric"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <input
                      value={formData.email}
                      onChange={handleChange}
                      name="email"
                      type="email"
                      placeholder="Email Address*"
                      className="form-control"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <select value={formData.occasion} onChange={handleChange} name="occasion" className="form-control">
                      <option value="">Select Occasion*</option>
                      {occasions.map((occasion, index) => (
                        <option key={index} value={occasion}>
                          {occasion}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <select
                      value={formData.consultation}
                      onChange={handleChange}
                      name="consultation"
                      className="form-control"
                    >
                      <option value="">Preferred Consultation*</option>
                      {consultationTypes.map((consultation, index) => (
                        <option key={index} value={consultation}>
                          {consultation}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <input
                      value={formData.wedding_date}
                      onChange={handleChange}
                      name="wedding_date"
                      type={formData.wedding_date ? "date" : "text"}
                      placeholder="Wedding Date (Approximate)"
                      className="form-control"
                      onFocus={(e) => (e.target.type = "date")}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          e.target.type = "text";
                        }
                      }}
                    />
                  </div>

                  <div className="col-lg-12 mb-3">
                    <ReCAPTCHA sitekey="6Lf3ClosAAAAAHBljufC2cFazfRU5LAe-0BQMprO" onChange={handleCaptcha} />
                  </div>

                  <div className="col-lg-12">
                    <button type="submit" className="default-btn red-default" disabled={loading}>
                      {loading ? "Submitting..." : "Reserve My Appointment"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
